import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MapPin, Boxes } from "lucide-react";

// HIS 10 RACKS HAVE NO SECTOR AT ALL — which is why they are nowhere in the yard tree. He assigns
// them himself, so they sit in one band at the top of the tab with one button each. Work down the
// list once and the band disappears on its own.
export const UnplacedRacksBand = ({ racks, canManage, onAssign, onContents }) => {
  if (!racks.length) return null;
  return (
    <div data-testid="unplaced-racks-band" className="mb-5 rounded-xl border-2 border-amber-300 bg-amber-50 overflow-hidden">
      <div className="px-3 py-2 flex items-center gap-2 border-b border-amber-200">
        <Boxes className="w-4 h-4 text-amber-700 shrink-0" />
        <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-amber-800 font-semibold" data-testid="unplaced-racks-count">
          {racks.length} built-in rack{racks.length === 1 ? "" : "s"} {racks.length === 1 ? "isn't" : "aren't"} in a sector yet
        </span>
        <span className="ml-auto text-[11px] text-amber-700 hidden sm:inline">
          Put each one in its sector and it joins the yard tree below. Everything on it comes with it.
        </span>
      </div>
      <div className="divide-y divide-amber-100">
        {racks.map((r) => (
          <div key={r.id} data-testid={`unplaced-rack-${r.short_code}`} className="flex flex-wrap items-center gap-2 px-3 py-2 min-h-[48px]">
            <span className="font-semibold text-sm text-slate-800">{r.name}</span>
            <Badge className="rounded-lg bg-white border border-amber-200 text-slate-700 text-[9px] font-mono">{r.short_code}</Badge>
            <span className="font-mono text-[10px] text-slate-500">
              {r.child_count} {r.child_count === 1 ? "shelf" : "shelves"}
            </span>
            <div className="ml-auto flex items-center gap-2">
              <Button data-testid={`unplaced-contents-${r.short_code}`} size="sm" variant="outline"
                className="rounded-lg h-9 border-amber-300 text-amber-900 bg-white" onClick={() => onContents(r)}>
                What's on it
              </Button>
              {canManage && (
                <Button data-testid={`unplaced-assign-${r.short_code}`} size="sm"
                  className="rounded-lg h-9 bg-[#E0781A] hover:bg-[#C76714] text-white" onClick={() => onAssign(r)}>
                  <MapPin className="w-3.5 h-3.5 mr-1" />Put in a sector
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
